<template lang="pug">
.re-login
    .re-login-component
        template(v-if="!selectAccount")
            .re-login-box(v-if="!verificationCodeSent")
                .re-login-body
                    h2.box-form-title {{ title }}
                    p.box-form-head-message(v-if="showNotice" v-html="notice")

                    .re-registration-plug
                        .register-container {{ $$t('register.label') }}
                            router-link(:to="{ name: $$s('register.route') }") {{ $$t('register.link') }}

                    re-toast-alert(v-if="emailVerificationSuccess === true" type="info") Email is verified, please log in
                    re-toast-alert(v-if="emailVerificationSuccess === false" type="danger") Email is not verified, please try again

                    re-modal.verify-account-error(v-if="showingVerificationError" container-class="re-modal-sm" @close="showingVerificationError = false")
                        .re-modal-title Registration not verified
                        .re-modal-content
                            re-verify-account-error(:email="verificationEmail" resetTitle="" resetButtonTitle="Resend")

                    p.box-form-head-error(v-show="!!formErrorMessage" v-html="formErrorMessage")
                    .login-inputs-box
                        .re-inp-box.re-inp-box--with-icon
                            re-input(
                                v-model.trim="$v.fields.username.$model"
                                v-bind="getFieldProps('username', {type: 'email', defaults: {label: 'Email'}})"
                            )
                            .re-inp-box__icon
                                img(src="/images/client/got-me-hookd/input-icon-envelope.svg")
                        .re-inp-box.re-inp-box--with-icon
                            re-input(
                                v-model.trim="$v.fields.password.$model"
                                v-bind="getFieldProps('password', {type: 'password', defaults: {label: 'Password'}})"
                                :type="showPassword ? 'text' : 'password'"
                            )
                            re-input-eye-icon(v-model="showPassword")

                    .login-form-footer
                        re-checkbox(v-model="fields.remember_me") {{ $$t('rememberMe.label') }}
                        router-link.re-forgot-password(:to="{ name: $$s('forgotPassword.route') }") {{ $$t('forgotPassword.label', 'Forgot Password?') }}
                    .re-submit-button-container
                        re-button.re-button--primary.re-button--sm.re-submit-button(@click="loginNow" :loading="isLoggingIn") {{ submitButtonTitle }}
            login-2fa(v-else ref="login2fa" :phone="phoneNumber" @submit="verificationSubmit")
        template(v-else)
            .re-login-box
                .re-login-body
                    h2.box-form-title Select account
                    .assistables-list
                        re-button.re-button--secondary.select-assistable(@click="redirectOnAuth()")
                            .button-content
                                span
                                    strong Your Own Account
                                img(src="/images/client/got-me-hookd/right-arrow-small.svg" alt="")
                        template(v-for="assistable in authUser.assistables")
                            re-button.re-button--secondary.select-assistable(@click="assist(assistable.id)") 
                                .button-content
                                    span {{ assistable.name }}
                                    img(src="/images/client/got-me-hookd/right-arrow-small.svg" alt="")

</template>

<script>
import ReLogin from 'utils/vue/components/complex/user/re-login/script.js'
import { EventBus } from 'utils/vue/components/complex/user/re-login/config'
import { mapGetters } from 'vuex'
import Cookie from 'js-cookie'

export default {
    name: 'gmh-login',

    mixins: [
        ReLogin,
    ],

    data() {
        return {
            showPassword: false,
            verificationCodeSent: false,
            phoneNumber: null,
            fields: {
                remember_me: false,
            },
            selectAccount: false,
            emailVerificationSuccess: null,
        }
    },

    computed: {
        ...mapGetters(['authUser']),
    },

    async created() {
        EventBus.$on('user.login.success', () => {
            this.$store.dispatch('Shop/Orders/Cart/clearCart')
        })

        if (this.$route.query['email-verification-token']) {
            try {
                await axios.post(`/api/user/email-verification/check`, {
                    token: this.$route.query['email-verification-token'],
                    email: this.$route.query.email,
                })
                this.emailVerificationSuccess = true
            } catch (e) {
                this.emailVerificationSuccess = false
            }
        }
    },

    methods: {
        verificationSubmit(value) {
            this.fields.code_2fa = value
            this.loginNow()
        },

        async loginNow(event) {
            this.isLoggingIn = false
            this.resetFieldsValidation()
            this.showingVerificationError = false
            const fields = _.cloneDeep(this.fields)
            const publicFields = _.omit(fields, ['password'])
            this.emit('before', publicFields)
            this.$emit('before', publicFields)
            this.$v.$touch()
            this.formSubmitting = true
            if (!this.isAnyInvalid) {
                this.$emit('valid', fields)
                this.emit('valid', fields)
                if (this.disableActions) {
                    return
                }
                this.isLoggingIn = true
                try {
                    this.$emit('init', publicFields)
                    this.emit('init', publicFields)
                    const [data] = await this.promise('user.login', fields)

                    if (data.requirement) {
                        if (data.requirement === 'sms_verification_code') {
                            this.verificationCodeSent = true
                            this.fields.code_2fa = ''
                            this.phoneNumber = data.meta.phone
                        }
                    } else {
                        await this.finalizeLogin(data, publicFields)

                        this.emit('success', data, fields)
                        this.$emit('success', data, fields)
                        this.resetForm()

                        if (this.authUser.assistables && this.authUser.assistables.length) {
                            this.selectAccount = true
                        } else {
                            this.redirectOnAuth()
                        }
                    }
                } catch (e) {
                    this.isLoggingIn = false
                    this.emit('error', e, publicFields)
                    this.$emit('error', e, publicFields)
                    this.showLoginFormError(e, {form: publicFields, 'scrollTo': '.re-login-box'})

                    if (this.verificationCodeSent) {
                        this.$refs.login2fa.showValidationError()
                    }
                } finally {
                    this.emit('end', publicFields)
                    this.$emit('end', publicFields)
                }
            } else {
                this.emit('invalid', publicFields)
                this.$emit('invalid', publicFields)
                this.scrollToFirstErrorElement()
            }
        },

        async assist(id) {
            Cookie.remove('remember_me')

            const { data } = await axios.post(`/api/customer/user/${id}/assist`)

            this.$store.dispatch('saveToken', {
                token: data.access_token
            })

            await this.$store.dispatch('fetchUser')

            this.redirectOnAuth()
        },
    }
}
</script>
